import { SubscriptionData, ComponentPreference } from '@ecri/react-components';
export const LOADING_SUBSCRIPTIONS = 'LOADING_SUBSCRIPTIONS';
export const LOADED_SUBSCRIPTIONS = 'LOADED_SUBSCRIPTIONS';
export const LOADING_USER_SUBSCRIPTIONS = 'LOADING_USER_SUBSCRIPTIONS';
export const LOADED_USER_SUBSCRIPTIONS = 'LOADED_USER_SUBSCRIPTIONS';
export const SAVING_USER_PREFERENCES = 'SAVING_USER_PREFERENCES';
export const SAVING_USER_PREFERENCES_ERROR = 'SAVING_USER_PREFERENCES_ERROR';
export const SAVED_USER_PREFERENCES = 'SAVED_USER_PREFERENCES';

export interface SavingUserPreferencesAction {
  type: typeof SAVING_USER_PREFERENCES;
  payload: ComponentPreference[];
}

export interface LoadedUserSubscriptions {
  type: typeof LOADED_USER_SUBSCRIPTIONS;
  payload: SubscriptionData;
}

export interface SavedUserPreferencesAction {
  type: typeof SAVED_USER_PREFERENCES;
  payload: ComponentPreference[];
}

export interface LoadingSubscriptionsAction {
  type: typeof LOADING_SUBSCRIPTIONS;
}

export interface LoadedSubscriptionsAction {
  type: typeof LOADED_SUBSCRIPTIONS;
  payload: SubscriptionData;
}

export interface SavingUserPreferencesErrorAction {
  type: typeof SAVING_USER_PREFERENCES_ERROR;
  payload: string;
}

export type SubscriptionActionTypes =
  | LoadingSubscriptionsAction
  | LoadedSubscriptionsAction
  | LoadedUserSubscriptions
  | SavingUserPreferencesAction
  | SavingUserPreferencesErrorAction
  | SavedUserPreferencesAction;

export enum SubscriptionLoadingStatus {
  Initial,
  Loading,
  Updating,
  Loaded,
  Error,
}

export interface UserSubscriptionViewModel {
  memberUserId: number;
  subscriptionDetails: SubscriptionData;
}
export interface SubscriptionState extends SubscriptionData {
  loadState: SubscriptionLoadingStatus;
  userDataLoaded: boolean;
  globalDataLoaded: boolean;
}
